import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Menu } from '../Menu';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { Router } from '@angular/router';
import { ChatService } from '@app/services/chat.service';
import { GlobalmenuService } from '@app/services/globalmenu.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OfferpackService } from '@app/services/offerpack.service';
import { AuthService } from '@app/services/auth.service';
import { Customer } from '@app/models/customers/Customer';

@Component({
    selector: 'clever-menu2',
    templateUrl: './menu2.component.html',
    styleUrls: ['./menu2.component.scss'],
    standalone: false
})
export class Menu2Component implements OnInit {
    @Input() deskmode: string;
    @Input() mobile: boolean;
    @Input() showChat: boolean;
    @Input() showTermin: boolean;
    @Input() showhReisekompass: boolean;
    @Input() showhLogin: boolean;
    @Input() showhDigbrater: boolean;
    currentCustomer: Customer;

    offerpackCount: number = 0;
    destroyRef = inject(DestroyRef);

    constructor(
        protected mymenu: Menu,
        protected router: Router,
        protected chatService: ChatService,
        protected guardService: AuthGuardService,
        protected menuService: GlobalmenuService,
        protected authService: AuthService,
        protected offerpackService: OfferpackService,
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.initData();
        this.initOfferpack();
    }

    async initData() {
        this.authService.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            if (customer?.email?.length > 0) {
                this.currentCustomer = customer;
                this.cdr.markForCheck();
            }
        });
    }

    async initOfferpack() {
        this.offerpackService.offerpack$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((count: number) => {
            this.offerpackCount = count;
            this.cdr.markForCheck();
        });
    }

    async opensubmenu(mm, ev) {
        ev.stopPropagation();
        if (!mm.isItem) {
            if (mm.column?.length > 0) {
                const tmp = {
                    title: mm.title,
                    menus: []
                };
                for (let i = 0; i < mm.column.length; i++) {
                    for (let j = 0; j < mm.column[i].menus.length; j++) {
                        tmp.menus.push(mm.column[i].menus[j]);
                    }
                }
                this.mymenu.setCurrentMenu2(tmp);
            } else {
                this.mymenu.setCurrentMenu2(mm);
            }
        }
    }

    async gobackMenu(ev) {
        ev.stopPropagation();
        this.mymenu.goBack2();
    }

    closeMenuF() {
        // this.closeMenu.emit(true);
    }

    async gotoOfferpack() {
        const url = this.router.createUrlTree(['offerpack']).toString();
        this.router.navigateByUrl(url);
    }

    async gotoCalendar() {
        this.router.navigate(['terminkalender']);
    }

    openChat() {
        this.chatService.setOpenChat();
    }

    async gotoContent() {
        const url = this.router.createUrlTree(['contents']).toString();
        this.router.navigateByUrl(url);
    }

    async gotoAnfrage() {
        const url = this.router.createUrlTree(['anfrage']).toString();
        this.router.navigateByUrl(url);
    }

    async gotofavorites() {
        const url = this.router.createUrlTree(['favorites']).toString();
        this.router.navigateByUrl(url);
    }
}
